/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { Store } from '@ngrx/store';
import * as fromRoot from '@api/store/app-store';
import * as ui from '@api/store/actions/ui.actions';
import * as user from '@api/store/actions/user.actions';

import { Menu } from '@api/models/menu';

/**
 * This class represents the navigation bar component.
 */
@Component({
  selector: 'main-navbar',
  template: require('./navbar.component.html')
})
export class NavbarComponent {
 
  menuItems$: Observable<Menu[]>;
  collapsed$: Observable<boolean>;

  constructor(public store: Store<fromRoot.AppState>, private _router: Router) {
    this.menuItems$ = store.select(fromRoot.getMenus);
    this.collapsed$ = store.select(fromRoot.getCollapsedSidenav);
  }

  menuClick(menuItem: any) {
    this.store.dispatch(new ui.CloseSidenavAction());
  }

  toggleMenuCollapse($event: Event) {
    $event.preventDefault();
    this.store.dispatch(new ui.ToggleSidenavAction());
  }

  public logoutClick() {
    this.store.dispatch(new user.LogoffAction());
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/components/navbar/navbar.component.ts